<template>
  <div class="main">
    <Spinner class="is-size-3" v-if="isLoading" />

    <div class="notification is-danger" v-if="gamecamLogLoadError">{{ gamecamLogLoadError }}</div>

    <div class="container" v-if="logEmpty == false">
      <!-- Top card -->
      <div class="card">
        <!-- Top card header -->
        <header class="card-header">
          <div class="card-header-title">
            <div class="media">
              <div class="media-content">
                <p class="title is-4">{{ email }}</p>
              </div>
            </div>
          </div>
        </header>
      </div>

      <!-- Bottom tabs -->
      <div class="tabs is-toggle is-fullwidth bottom-tabs">
        <ul>
          <li v-for="tab in bottomTabs"
            :key="tab.index"
            :class="{'is-active': tab.index === selectedBottomTabIndex}"
            @click="selectBottomTab(tab)">

            <a>{{tab.name}}</a>
          </li>
        </ul>
      </div>

      <!-- Bottom tab content -->
      <div class="tabs-content">
        <component
          :is="selectedBottomTabComponent"
          :gamecamStorePath="gamecamStorePath" />
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from "@/components/utils/Spinner";
import GamecamLogTab from "./GamecamLogTab";
import GamecamHuntAreasTab from "./GamecamHuntAreasTab";

import {
  GET_EMAIL,
  IS_LOADING_LOG,
  GET_LOG_LOAD_ERROR,
  GET_LOG
} from "./gamecamStore";

export default {
  name: "Gamecam",

  components: { Spinner },

  props: {
    gamecamStorePath: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      bottomTabs: [
        {
          index: 0,
          name: "Log",
          component: GamecamLogTab
        },
        {
          index: 1,
          name: "Configured Hunt Areas",
          component: GamecamHuntAreasTab
        }
      ],
      selectedBottomTabIndex: 0,
      showChangeAdminModal: false
    };
  },

  methods: {
    selectBottomTab(tab) {
      this.selectedBottomTabIndex = tab.index;
    },
  },

  computed: {
    isLoading() {
      const isLoadingGamecamLog = `${this.gamecamStorePath}/${IS_LOADING_LOG}`;
      return this.$store.getters[isLoadingGamecamLog];
    },

    email() {
      const getEmail = `${this.gamecamStorePath}/${GET_EMAIL}`;
      return this.$store.getters[getEmail];
    },

    log() {
      const getLog = `${this.gamecamStorePath}/${GET_LOG}`;
      return this.$store.getters[getLog];
    },

    logEmpty() {
      if (!this.log) {
        return true;
      }

      return this.log.length == 0;
    },

    gamecamLogLoadError() {
      const getGamecamLogLoadError = `${this.gamecamStorePath}/${GET_LOG_LOAD_ERROR}`;
      return this.$store.getters[getGamecamLogLoadError];
    },

    selectedBottomTabComponent() {
      if (this.selectedBottomTabIndex === null) {
        return null;
      }

      return this.bottomTabs[this.selectedBottomTabIndex].component;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/style.scss";

.main {
  overflow: auto;
  padding: 10px;
}

.bottom-tabs.tabs {
  margin-top: $column-gap * 2;

  a {
    padding: 4px 16px;
  }
}

.tabs-content {
  overflow: auto;
}
</style>
